import { ViewRoute } from "./types";
import { RouteNames } from "@dcc/router/definitions";
import { DrinkFrequency } from "@dcc/types/drinkFrequency";

const routeMap = {
  [DrinkFrequency.Never]: RouteNames.nonDrinkResults,
  [DrinkFrequency.Weekly]: RouteNames.daysOfWeek,
  [DrinkFrequency.TwiceMonthly]: RouteNames.monthlydays,
  [DrinkFrequency.Monthly]: RouteNames.averageDay
};

export const DrinkFrequencyRoute: ViewRoute = {
  [RouteNames.drinkFrequency]: (factors) => {
    return routeMap[factors.drinkingFrequency];
  }
};
